import $ from "jquery";

Array.prototype._one = function() {
  return this[0] || undefined;
};

export const subscribers = {};

export function throttle(fn, delay) {
  let timeout = null;
  let callNow = true;

  return function(...args) {
    const next = () => {
      fn.apply(this, args);
      timeout = null;
    };

    if (callNow) {
      callNow = false;
      next();
    }

    if (!timeout) {
      timeout = setTimeout(next, delay);
    }
  };
}

export function debounce(fn, delay) {
  let timer = null;

  return (...args) => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

export function subscribe(name, fn) {
  if (!subscribers[name]) {
    subscribers[name] = [];
  }

  subscribers[name].push(fn);
}

export function publish(name, data = {}) {
  if (subscribers[name]) {
    subscribers[name].forEach(subscriber => {
      subscriber(data);
    });
  }
}

export function nextTick(time = 0) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, time);
  });
}

function traversal(direction, name) {
  const directions = {
    up: "parents",
    down: "find"
  };

  const _components = Array.from(
    this.$.root[directions[direction]]('[class*="js-"]')
  )
    .filter(node => Boolean(node.component))
    .map(item => item.component);

  return name
    ? _components.filter(component => (name ? component.name === name : true))
    : _components;
}

const addElements = function() {
  for (let element in this.classList) {
    if (element !== "root") {
      this.$[element] = this.$.root.find(this.classList[element]);
    }
  }
};

export const $window = $(window);
export const $document = $(document);
export const $body = $(".js-body");
export const $page = $(".js-page");

export default class Component {
  constructor(element, options) {
    this.name = options.name || this.selector.substr(4);
    this.state = Object.assign({}, options.state) || {};
    this.classList = options.classList;

    if ("dependencies" in options && options.dependencies.length) {
      options.dependencies.forEach(dependency => {
        this[dependency.name] = dependency;
      });
    }

    this.$ = {
      window: $window,
      document: $document,
      body: $body,
      page: $page,
      root: $(element)
    };

    addElements.call(this);

    if (this.$.root.length) {
      this.$.document.ready(() => {
        this.init && this.init();
        this.events && this.events();
        this.inited && this.inited();
      });
    }
  }
  elements() {
    addElements.call(this);
  }
  parents(name) {
    return traversal.call(this, "up", name);
  }
  childs(name) {
    return traversal.call(this, "down", name);
  }
  // deprecated, use 'set'
  setState(state) {
    this.state = Object.assign({}, this.state, state);
  }
  set(state) {
    this.state = Object.assign({}, this.state, state);
  }
  get(prop) {
    return this.state[prop];
  }
  static mount(Constructor, options) {
    const $elements = $(options.classList.root);

    if (!Boolean($elements.length)) return {};

    const init = element => {
      try {
        return new Constructor(element, options);
      } catch (error) {
        return console.error(error), {};
      }
    };

    if (options.singleton) {
      const element = $elements.get(0);
      const component = init(element);

      element.component = component;

      return component;
    } else {
      return $elements.map((i, element) => {
        element.component = init(element);
        return element.component;
      });
    }
  }
}

if (typeof window !== "undefined") {
  window.Component = Component;
}
